/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import 'antd-mobile/dist/antd-mobile.css'
import MatchupFilterPopup from '@views/Popup/MatchupFilter'
import { BadgeStyle, LeftTabWrap, TotalTabWrap } from '@styles/base.style'
import { GAME_TYPE } from '@game-type/game-market-types'
import { LogoutType, PAGE_TYPE } from '@interface/common'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { isMobile } from 'react-device-detect'
import AdvCasinoAdvertisementButton from '@views/AdvCasino/Button'
import { SportTab } from '@views/Matchup/Tab/SportTab'
import GameTab from '@views/Matchup/Tab/GameTab'
import { LeagueTab } from '@views/Matchup/Tab/LeagueTab'
import MatchupFilterButton from '@views/Matchup/MatchUpFilter/Button'
import { MatchResultBtnStyle, GameTabWrap, MathUpClubMarkImgStyle } from './index.style'
import { AdvButton } from '@components/Button'
import Login from '@views/Login'
import { ClubEventWrap } from '@views/Matchup/ClubInfo/index.style'
import { Button } from '@styles/button.style'
import ClubEventBtnImg from '@assets/images/btn/club-event-btn.png'
import { Badge } from 'antd-mobile'
import * as Utils from '@utils/utils'
import _ from 'lodash'
import ClubEventModal from '@views/Matchup/ClubInfo/ClubEventModal'
import EventFloatingButton from '@views/Matchup/EventFloatingButton'
import ClubNoticePopup from '@views/Popup/ClubInfo/ClubNoticePopup'
import AdvImg from '@components/AdvImg'
import { loadOrReload } from '@utils/utils'
import RankingPopupButton from '@views/Popup/RankingPopup/Button'
import LeagueFilterIcon from '@assets/images/icon/ranking_event_icon/league-filter.png'

export interface MatchTabProps {
  pageType?: PAGE_TYPE
}

const MatchTab: React.FC<MatchTabProps> = (props: MatchTabProps) => {
  // 매치업 필터 팝업
  const {
    matchupStore, oddsStore, authStore, globalStore, componentStore, logStore, userStore, rankingEventStore,
  } = useRootStore()
  const { club = {}, clubNoticeHistories, currentGameKey } = matchupStore
  const { name, backgroundImageUrl, grade } = club
  const { notificationData } = userStore
  const { pageType } = props
  const [sportsTabClassName, setSportsTabClassName] = useState('sport-tab')
  const [subTabClassName, setSubTabClassName] = useState('league-tab white-num no-flex')
  const [visibleClubEventModal, setVisibleClubEventModal] = useState(false)
  const scorePageTitle = globalStore.getScorePageTitle()
  const { body } = document
  const htmlElem = document.getElementsByTagName('html')[0]
  const isTestAccount = Utils.isAccountForTesting(authStore.userInfo?.id || '')
  const isFirstRenderRef = useRef(true)

  const PCBetslip = document.querySelector('#pcBetslip')
  const PCMainHeader = document.querySelector('#pcMainHeader')

  const scrollY = 185

  const scrollHandler = () => {
    if (htmlElem.scrollTop > scrollY || body.scrollTop > scrollY) {
      setSportsTabClassName('sport-tab fixed-tab')
      setSubTabClassName('league-tab fixed-tab white-num no-flex')
    } else {
      setSportsTabClassName('sport-tab')
      setSubTabClassName('league-tab white-num no-flex')
    }
  }

  let pcTabStyle
  if (!isMobile) {
    pcTabStyle = 'show-scroll'
  }

  // 홈에서 세팅한 상태값 초기화(뒤로가기로 경기결과 복귀시 남아있는 현상 방지), 첫 렌더에만 실행
  // 0010759: [V2공통] 경기결과에서 홈 이동 후 단말 뒤로가기 시 경기 리스트가 0건으로 출력되는 현상
  // https://task.zempublic.co.kr/view.php?id=10759
  if (isFirstRenderRef.current && pageType === PAGE_TYPE.MATCHUP) {
    matchupStore.setMatchTabInitializeMajorUniqueId(undefined)
    matchupStore.setMajorUniqueID(undefined)
    isFirstRenderRef.current = false
  }

  useOnMount(async () => {
    componentStore.updateIsVisibleEtcAlertOptions()
    await matchupStore.fetchMajorTournamentFilters()
    if (currentGameKey !== GAME_TYPE.LIVE && oddsStore.isOddsConnected) {
      oddsStore.cleanup()
    }

    if (isMobile) {
      window.addEventListener('scroll', scrollHandler, true)
    }

    if (authStore.isForceShowLoginPopup) {
      if (authStore.isSignedIn) {
        authStore.logout(LogoutType.USER, false).then(() => {
          authStore.showLoginPopup(<Login/>)
          authStore.setIsForceShowLoginPopup(false)
        }).catch(console.error)
      } else {
        authStore.showLoginPopup(<Login/>)
        authStore.setIsForceShowLoginPopup(false)
      }
    }
  })

  useOnUnmount(() => {
    if (isMobile) {
      window.removeEventListener('scroll', scrollHandler, true)
    }
  })

  let gameTabClassName
  if (notificationData.liveMatchCount > 0 ){
    gameTabClassName = 'match-tab-wrap is-live-badge'
  } else {
    gameTabClassName = 'match-tab-wrap'
  }

  const onClickMatchResult = () => {
    if (!authStore.isSignedIn) {
      authStore.showLoginPopup(<Login/>)
      return
    }

    logStore.writeButtonLog({ pageId: 'b010', buttonId: '003' }).catch(console.error)
    matchupStore.cleanup()
    loadOrReload('/matchupResult')
  }

  const eventNotices = club.eventNotices
  const validateNewClubEventBadge = () => {
    if (_.isEmpty(eventNotices)) {
      return false
    }

    return _.chain(eventNotices)
      .slice(0, 4)
      .find(notice => !_.includes(clubNoticeHistories, notice.id))
      .isEmpty()
      .value() === false
  }

  const hasNewClubEvent = validateNewClubEventBadge()

  const onClickToggle = (event: any) => {
    logStore.writeButtonLog({ pageId: 'b010', buttonId: '002' }).catch(console.error)
    componentStore.fetchHomeBanners().then((data) => {
      if (_.isEmpty(club.eventNotices) && _.chain(data).filter(i => i.clubEventPostEnabled).isEmpty().value()) {
        event.preventDefault()
        Utils.showToast(Utils.TOAST_TYPE.INFO, '진행중인 이벤트가 없습니다.')
      } else {
        if (!isMobile && PCBetslip) {
          PCBetslip.classList.toggle('z-index-0')
        }
        setVisibleClubEventModal(true)
      }
    })
  }

  const onLoadClubBackgroundImg = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.style.display = 'block'
  }

  /*
    [PC웹] 스크롤 추가 이슈 진행시 추가한 Header z-index 값으로 인해 추가한 코드입니다.
    [이슈링크](https://task.zempublic.co.kr/view.php?id=9598)
  */
  if (PCMainHeader){
    if (!isMobile && visibleClubEventModal){
      PCMainHeader.classList.add('z-index-0')
    } else {
      PCMainHeader.classList.remove('z-index-0')
    }
  }

  return (
    <Fragment>
      <LeftTabWrap className={gameTabClassName}>
        <GameTabWrap>
          <GameTab/>
          <AdvButton
            flex
            alignCenter
            bold
            height={42}
            color={'disableTxt2'}
            text={[scorePageTitle]}
            icoColor={'disableTxt2'}
            css={MatchResultBtnStyle}
            onClick={onClickMatchResult}
          />
        </GameTabWrap>

        {/* 카지노 버튼 */}
        {globalStore.getCasinoAdvertisementButtonDisplayEnabled() && (
          <AdvCasinoAdvertisementButton/>
        )}

        <div className="button-wrap">
          {/* ******************* 페이백 이벤트 버튼(PC) ******************* */}
          {/*TODO 출력이 안되고 있음 확인 해봐야함*/}
          {(!isMobile && authStore.isSignedIn) &&
            <EventFloatingButton className="match-tab"/>
          }

          {/* ******************* 랭킹 이벤트 버튼(PC) ******************* */}
          {/*TODO: 랭킹 현황을 볼 수 있는 팝업 및 버튼*/}
          <RankingPopupButton viewType="matchTab"/>
        </div>

        {/* ******************* 클럽/승부사 이벤트 버튼 ******************* */}
        {(!isTestAccount && authStore.isSignedIn) &&
          <ClubEventWrap>
            <Button TP className="club-event-btn" onClick={onClickToggle}>
              <AdvImg srcMode={'small'} src={ClubEventBtnImg} alt="이벤트 버튼"/>
              {hasNewClubEvent && (
                <Badge dot css={BadgeStyle} className="club-event-badge"/>
              )}
            </Button>
          </ClubEventWrap>
        }

        {/* ******************* 클럽/승부사 이벤트 팝업 ******************* */}
        {authStore.isSignedIn &&
          <ClubEventModal visible={visibleClubEventModal} setVisible={setVisibleClubEventModal}/>
        }

        {/* ******************* 클럽 아이콘 ******************* */}
        {authStore.isSignedIn && backgroundImageUrl && Utils.isMembershipClub(grade) &&
          <AdvImg css={MathUpClubMarkImgStyle} srcMode={'small'} src={backgroundImageUrl} alt={name}
                  className={!isMobile && 'pc'} onLoad={onLoadClubBackgroundImg}/>
        }

        {/* ******************* 클럽 공지사항 팝업 ******************* */}
        <ClubNoticePopup/>
      </LeftTabWrap>

      <TotalTabWrap fixed box iconTab className={isMobile ? sportsTabClassName : `${sportsTabClassName} show-scroll`}>
        <SportTab pageType={pageType}/>
      </TotalTabWrap>
      <TotalTabWrap childFixed underline className={`${subTabClassName} ${pcTabStyle} show-scroll`}>
        <LeagueTab pageType={pageType}/>
        <div className="filter-button-wrap">
          {globalStore.getRankingLeagueFilterEnabled() &&
            currentGameKey !== GAME_TYPE.LIVE &&
            rankingEventStore.hasOngoingEvent && (
            <Button
              className="league-filter-button"
              onClick={() => {
                matchupStore.setFilterEventOnly(true)
                globalStore.setVisibleMatchupFilterSelectPopup(true)
              }}
            >
              <div className="league-filter-button-content">
                <img src={LeagueFilterIcon} alt="리그필터" className="league-filter-icon"/>
                월드컵
              </div>
            </Button>
          )}
          {currentGameKey !== GAME_TYPE.LIVE && <MatchupFilterButton pageType={pageType}/>}
        </div>
      </TotalTabWrap>
      <MatchupFilterPopup/>
    </Fragment>
  )
}

export default observer(MatchTab)
